import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import i18n, { translate } from './strings/i18n';
import ErrorMessage from './modal/content/utils/ErrorMessage';
import getImages from './modal/content/helpers/get-images';
import { DefaultProviders } from '../default-providers';
import ConfigContextProvider from './context';
import ManageCardHoldersMainModal from './modal/content/main-modal';
const ManageCardHoldersRoot = ({ config, selectedAccountId, handleClose, authenticationRedirect }) => {
    const languageInStorage = localStorage.getItem('language');
    const currentState = {
        config,
        selectedAccountId,
        handleClose,
        authenticationRedirect
    };
    useEffect(() => {
        if (languageInStorage) {
            i18n.changeLanguage(languageInStorage).catch(error => error);
        }
        else {
            localStorage.setItem('language', 'en');
        }
    }, [languageInStorage]);
    const { error: errorImage } = getImages({ config });
    return (_jsx(ErrorBoundary, { fallback: _jsx(ErrorMessage, { id: "mch-error-boundary", image: errorImage, title: translate('errorMessages.troubleRetrievingInformation'), subTitle: translate('errorMessages.tryAgainLater') }), children: _jsx(DefaultProviders, { config: config, children: _jsx(ConfigContextProvider, { state: currentState, children: _jsx(ManageCardHoldersMainModal, {}) }) }) }));
};
export default ManageCardHoldersRoot;
